import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SeriousCasesListComponent } from './serious-cases-list/serious-cases-list.component';

const routes: Routes = [
    {
        path: 'serious-cases',
        children: [
            { path: '', component: SeriousCasesListComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SeriousCasesRoutingModule { }
